
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * WARNING: This is an internal file that is subject to change!
 *
 * 🛑 Under no circumstances should you import this file directly! 🛑
 *
 * All exports from this file are wrapped under a `Prisma` namespace object in the browser.ts file.
 * While this enables partial backward compatibility, it is not part of the stable public API.
 *
 * If you are looking for your Models, Enums, and Input Types, please import them from the respective
 * model files in the `model` directory!
 */

import * as runtime from "@prisma/client/runtime/index-browser"

export type * from '../models.ts'
export type * from './prismaNamespace.ts'

export const Decimal = runtime.Decimal


export const NullTypes = {
  DbNull: runtime.NullTypes.DbNull as (new (secret: never) => typeof runtime.DbNull),
  JsonNull: runtime.NullTypes.JsonNull as (new (secret: never) => typeof runtime.JsonNull),
  AnyNull: runtime.NullTypes.AnyNull as (new (secret: never) => typeof runtime.AnyNull),
}
/**
 * Helper for filtering JSON entries that have `null` on the database (empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const DbNull = runtime.DbNull

/**
 * Helper for filtering JSON entries that have JSON `null` values (not empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const JsonNull = runtime.JsonNull

/**
 * Helper for filtering JSON entries that are `Prisma.DbNull` or `Prisma.JsonNull`
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const AnyNull = runtime.AnyNull


export const ModelName = {
  Company: 'Company',
  Department: 'Department',
  Users: 'Users',
  UserRoles: 'UserRoles',
  DepartmentUsers: 'DepartmentUsers',
  JobPosting: 'JobPosting',
  JobApplication: 'JobApplication',
  JobApplicationDocument: 'JobApplicationDocument',
  JobApplicationCandidateDetails: 'JobApplicationCandidateDetails',
  Candidate: 'Candidate',
  CandidateExperience: 'CandidateExperience',
  CandidateExperienceRole: 'CandidateExperienceRole',
  CandidateExperienceProject: 'CandidateExperienceProject',
  CandidateQualification: 'CandidateQualification',
  CandidateSkill: 'CandidateSkill',
  Source: 'Source',
  WhatsAppThread: 'WhatsAppThread',
  WhatsAppHistory: 'WhatsAppHistory',
  Metrics: 'Metrics',
  Interview: 'Interview',
  InterviewRound: 'InterviewRound',
  PanellistFeedback: 'PanellistFeedback',
  AssessmentTemplate: 'AssessmentTemplate',
  AssessmentParameter: 'AssessmentParameter',
  AssessmentTemplateParameters: 'AssessmentTemplateParameters',
  ParameterRating: 'ParameterRating',
  InterviewPanelistParameterAssignment: 'InterviewPanelistParameterAssignment',
  ScreeningInterview: 'ScreeningInterview',
  ScreeningCall: 'ScreeningCall',
  PhoneCallLifecycleEvent: 'PhoneCallLifecycleEvent',
  ScreeningResult: 'ScreeningResult',
  ScreeningSystemMessages: 'ScreeningSystemMessages',
  SystemSettings: 'SystemSettings',
  InterviewResult: 'InterviewResult',
  ScreeningResultCategories: 'ScreeningResultCategories',
  CompanyConfig: 'CompanyConfig',
  Integration: 'Integration',
  CustomFieldDefinition: 'CustomFieldDefinition',
  DefaultApprovers: 'DefaultApprovers',
  JobApprovers: 'JobApprovers',
  ApprovalRoutingRule: 'ApprovalRoutingRule',
  ApprovalRoutingApprover: 'ApprovalRoutingApprover',
  Approvals: 'Approvals',
  JobOffers: 'JobOffers',
  JobOfferDocuments: 'JobOfferDocuments',
  Notification: 'Notification',
  DailyWebhookEvent: 'DailyWebhookEvent',
  candidateNotes: 'candidateNotes',
  JobOpenings: 'JobOpenings',
  OfferTemplateDocuments: 'OfferTemplateDocuments',
  FaceLivenessVerification: 'FaceLivenessVerification',
  SearchTriggerErrors: 'SearchTriggerErrors',
  candidate_search_trigger_errors: 'candidate_search_trigger_errors',
  StatusChangeMetrics: 'StatusChangeMetrics',
  AdminAuditLogs: 'AdminAuditLogs',
  CustomChartConfig: 'CustomChartConfig',
  Embedding: 'Embedding',
  JobDescription: 'JobDescription',
  JDLangGraphState: 'JDLangGraphState',
  ReferenceJD: 'ReferenceJD',
  InviteResponse: 'InviteResponse',
  InterviewDeclineNotification: 'InterviewDeclineNotification',
  DocumentRequests: 'DocumentRequests',
  CandidateSharing: 'CandidateSharing',
  TalentPoolJobInvite: 'TalentPoolJobInvite',
  JobSourcedCandidate: 'JobSourcedCandidate',
  JDAgentConversation: 'JDAgentConversation',
  CommunicationServiceStatus: 'CommunicationServiceStatus',
  CommunicationTemplate: 'CommunicationTemplate',
  BillingCreditCostSet: 'BillingCreditCostSet',
  BillingPlan: 'BillingPlan',
  CompanyCreditBalance: 'CompanyCreditBalance',
  BillingCreditLedger: 'BillingCreditLedger',
  BillingSubscription: 'BillingSubscription',
  BillingCapacityGrant: 'BillingCapacityGrant',
  BillingSignupDraft: 'BillingSignupDraft',
  OneTimePassword: 'OneTimePassword',
  BillingEventLedger: 'BillingEventLedger',
  InterviewQualityReport: 'InterviewQualityReport',
  InterviewQualityIssue: 'InterviewQualityIssue',
  InterviewQualityRun: 'InterviewQualityRun'
} as const

export type ModelName = (typeof ModelName)[keyof typeof ModelName]

/*
 * Enums
 */

export const TransactionIsolationLevel = runtime.makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
} as const)

export type TransactionIsolationLevel = (typeof TransactionIsolationLevel)[keyof typeof TransactionIsolationLevel]


export const CompanyScalarFieldEnum = {
  id: 'id',
  companySlug: 'companySlug',
  companyName: 'companyName',
  externalAccountId: 'externalAccountId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archived: 'archived',
  archivedAt: 'archivedAt',
  description: 'description',
  stripeCustomerId: 'stripeCustomerId',
  linkedInCompanyId: 'linkedInCompanyId',
  creditCostSetId: 'creditCostSetId'
} as const

export type CompanyScalarFieldEnum = (typeof CompanyScalarFieldEnum)[keyof typeof CompanyScalarFieldEnum]


export const DepartmentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  companyId: 'companyId',
  departmentName: 'departmentName',
  departmentConfig: 'departmentConfig',
  naukriIndustry: 'naukriIndustry'
} as const

export type DepartmentScalarFieldEnum = (typeof DepartmentScalarFieldEnum)[keyof typeof DepartmentScalarFieldEnum]


export const UsersScalarFieldEnum = {
  id: 'id',
  authUserId: 'authUserId',
  userEmail: 'userEmail',
  companyId: 'companyId',
  createdAt: 'createdAt',
  disabled: 'disabled',
  source: 'source',
  name: 'name',
  reportsToId: 'reportsToId'
} as const

export type UsersScalarFieldEnum = (typeof UsersScalarFieldEnum)[keyof typeof UsersScalarFieldEnum]


export const UserRolesScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  roleName: 'roleName',
  roleWeight: 'roleWeight'
} as const

export type UserRolesScalarFieldEnum = (typeof UserRolesScalarFieldEnum)[keyof typeof UserRolesScalarFieldEnum]


export const DepartmentUsersScalarFieldEnum = {
  userId: 'userId',
  departmentId: 'departmentId'
} as const

export type DepartmentUsersScalarFieldEnum = (typeof DepartmentUsersScalarFieldEnum)[keyof typeof DepartmentUsersScalarFieldEnum]


export const JobPostingScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  companyId: 'companyId',
  deletedAt: 'deletedAt',
  isDeleted: 'isDeleted',
  ownerUserId: 'ownerUserId',
  hiringManagerUserId: 'hiringManagerUserId',
  hiringManagerEmail: 'hiringManagerEmail',
  recruiterEmail: 'recruiterEmail',
  jobDescriptionId: 'jobDescriptionId',
  title: 'title',
  interviewerEmail: 'interviewerEmail',
  departmentId: 'departmentId',
  level: 'level',
  location: 'location',
  ogImageUrl: 'ogImageUrl',
  ogImageSourceHash: 'ogImageSourceHash',
  country: 'country',
  currency: 'currency',
  internalOnly: 'internalOnly',
  relocationSupport: 'relocationSupport',
  jobDescriptionUrl: 'jobDescriptionUrl',
  employmentType: 'employmentType',
  educationalRequirements: 'educationalRequirements',
  minWorkExperience: 'minWorkExperience',
  minSalaryExpectation: 'minSalaryExpectation',
  maxSalaryExpectation: 'maxSalaryExpectation',
  preferredTargetEducation: 'preferredTargetEducation',
  preferredTargetOrganizations: 'preferredTargetOrganizations',
  newOrReplacement: 'newOrReplacement',
  processingStatus: 'processingStatus',
  processingStatusProgress: 'processingStatusProgress',
  visibility: 'visibility',
  parsedJobDescription: 'parsedJobDescription',
  screeningInterviewFocusArea: 'screeningInterviewFocusArea',
  externalJobId: 'externalJobId',
  integrationJobId: 'integrationJobId',
  isApproved: 'isApproved',
  naukriJobId: 'naukriJobId',
  naukriJobUrl: 'naukriJobUrl',
  assessmentTemplateId: 'assessmentTemplateId',
  phoneScreeningConfig: 'phoneScreeningConfig',
  customFields: 'customFields',
  activityHistory: 'activityHistory',
  screeningConfig: 'screeningConfig',
  extractedText: 'extractedText',
  searchableContent: 'searchableContent',
  lastSearchIndexUpdate: 'lastSearchIndexUpdate',
  positionHoldComments: 'positionHoldComments',
  positionClosedComments: 'positionClosedComments',
  searchableStandardizedRoles: 'searchableStandardizedRoles',
  functionalDomains: 'functionalDomains'
} as const

export type JobPostingScalarFieldEnum = (typeof JobPostingScalarFieldEnum)[keyof typeof JobPostingScalarFieldEnum]


export const JobApplicationScalarFieldEnum = {
  id: 'id',
  jacdId: 'jacdId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  statusChangeDate: 'statusChangeDate',
  companyId: 'companyId',
  jobPostingId: 'jobPostingId',
  applicationType: 'applicationType',
  uploadSource: 'uploadSource',
  uploadFileName: 'uploadFileName',
  processingAttempts: 'processingAttempts',
  processingClaimedAt: 'processingClaimedAt',
  processingWorkflowId: 'processingWorkflowId',
  queueEligible: 'queueEligible',
  processingQueuedAt: 'processingQueuedAt',
  currentCompensation: 'currentCompensation',
  expectedCompensation: 'expectedCompensation',
  currency: 'currency',
  status: 'status',
  score: 'score',
  scoreSummary: 'scoreSummary',
  isValidResume: 'isValidResume',
  deletedAt: 'deletedAt',
  isDeleted: 'isDeleted',
  appliedBy: 'appliedBy',
  sourceId: 'sourceId',
  refereeEmployeeId: 'refereeEmployeeId',
  refereePhone: 'refereePhone',
  refereeFirstName: 'refereeFirstName',
  refereeLastName: 'refereeLastName',
  relationshipToCandidate: 'relationshipToCandidate',
  refereeEmail: 'refereeEmail',
  referralStatus: 'referralStatus',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  phone: 'phone',
  linkedInUrl: 'linkedInUrl',
  resumeUrl: 'resumeUrl',
  currentCompany: 'currentCompany',
  spokenLanguages: 'spokenLanguages',
  technicalTools: 'technicalTools',
  currentDesignation: 'currentDesignation',
  previousCompaniesTop3: 'previousCompaniesTop3',
  industryExperienceTop3: 'industryExperienceTop3',
  latestDegree: 'latestDegree',
  latestInstitution: 'latestInstitution',
  yearOfGraduation: 'yearOfGraduation',
  yearsOfExperience: 'yearsOfExperience',
  location: 'location',
  peopleManagement: 'peopleManagement',
  noticePeriodInDays: 'noticePeriodInDays',
  processingStatus: 'processingStatus',
  processingStatusProgress: 'processingStatusProgress',
  profileVerified: 'profileVerified',
  notes: 'notes',
  parsedResume: 'parsedResume',
  naukriJobApplicationId: 'naukriJobApplicationId',
  customFields: 'customFields',
  workshortAssessments: 'workshortAssessments',
  activityHistory: 'activityHistory',
  searchableRoleTitles: 'searchableRoleTitles',
  searchableTechnicalSkills: 'searchableTechnicalSkills',
  searchableCompanies: 'searchableCompanies',
  searchableLanguages: 'searchableLanguages',
  searchableQualifications: 'searchableQualifications',
  isApproved: 'isApproved',
  isShortlisted: 'isShortlisted',
  extractedText: 'extractedText'
} as const

export type JobApplicationScalarFieldEnum = (typeof JobApplicationScalarFieldEnum)[keyof typeof JobApplicationScalarFieldEnum]


export const JobApplicationDocumentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  companyId: 'companyId',
  documentUrl: 'documentUrl',
  jobApplicationId: 'jobApplicationId'
} as const

export type JobApplicationDocumentScalarFieldEnum = (typeof JobApplicationDocumentScalarFieldEnum)[keyof typeof JobApplicationDocumentScalarFieldEnum]


export const JobApplicationCandidateDetailsScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  isCandidate: 'isCandidate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  externalCandidateId: 'externalCandidateId',
  deletedAt: 'deletedAt',
  isDeleted: 'isDeleted'
} as const

export type JobApplicationCandidateDetailsScalarFieldEnum = (typeof JobApplicationCandidateDetailsScalarFieldEnum)[keyof typeof JobApplicationCandidateDetailsScalarFieldEnum]


export const CandidateScalarFieldEnum = {
  id: 'id',
  jacdId: 'jacdId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  companyId: 'companyId',
  deletedAt: 'deletedAt',
  isDeleted: 'isDeleted',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  phone: 'phone',
  yearsOfExperience: 'yearsOfExperience',
  linkedInUrl: 'linkedInUrl',
  resumeUrl: 'resumeUrl',
  peopleManagement: 'peopleManagement',
  spokenLanguages: 'spokenLanguages',
  technicalTools: 'technicalTools',
  currentCompensation: 'currentCompensation',
  expectedCompensation: 'expectedCompensation',
  currency: 'currency',
  currentCompany: 'currentCompany',
  currentDesignation: 'currentDesignation',
  previousCompaniesTop3: 'previousCompaniesTop3',
  industryExperienceTop3: 'industryExperienceTop3',
  latestDegree: 'latestDegree',
  latestInstitution: 'latestInstitution',
  location: 'location',
  noticePeriodInDays: 'noticePeriodInDays',
  processingStatus: 'processingStatus',
  processingStatusProgress: 'processingStatusProgress',
  profileVerified: 'profileVerified',
  notes: 'notes',
  parsedResume: 'parsedResume',
  yearOfGraduation: 'yearOfGraduation',
  appliedBy: 'appliedBy',
  refereeEmployeeId: 'refereeEmployeeId',
  refereePhone: 'refereePhone',
  refereeFirstName: 'refereeFirstName',
  refereeLastName: 'refereeLastName',
  relationshipToCandidate: 'relationshipToCandidate',
  refereeEmail: 'refereeEmail',
  referralStatus: 'referralStatus',
  applicationType: 'applicationType',
  internalEmployeeNumber: 'internalEmployeeNumber',
  consultantCompanyName: 'consultantCompanyName',
  consultantName: 'consultantName',
  consultantEmail: 'consultantEmail',
  sourceId: 'sourceId',
  isValidResume: 'isValidResume',
  customFields: 'customFields',
  searchableRoleTitles: 'searchableRoleTitles',
  searchableLanguages: 'searchableLanguages',
  searchableQualifications: 'searchableQualifications',
  searchableCompanies: 'searchableCompanies',
  searchableTechnicalSkills: 'searchableTechnicalSkills',
  searchableSummary: 'searchableSummary',
  searchableStandardizedRoles: 'searchableStandardizedRoles',
  functionalDomains: 'functionalDomains',
  extractedText: 'extractedText'
} as const

export type CandidateScalarFieldEnum = (typeof CandidateScalarFieldEnum)[keyof typeof CandidateScalarFieldEnum]


export const CandidateExperienceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  jacdId: 'jacdId',
  industry: 'industry',
  description: 'description',
  designation: 'designation',
  companyName: 'companyName',
  location: 'location',
  duration: 'duration',
  startDate: 'startDate',
  endDate: 'endDate',
  currentlyEmployedAt: 'currentlyEmployedAt',
  employmentType: 'employmentType',
  extraInformation: 'extraInformation',
  teamLeadExperience: 'teamLeadExperience'
} as const

export type CandidateExperienceScalarFieldEnum = (typeof CandidateExperienceScalarFieldEnum)[keyof typeof CandidateExperienceScalarFieldEnum]


export const CandidateExperienceRoleScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  location: 'location',
  designation: 'designation',
  startDate: 'startDate',
  endDate: 'endDate',
  description: 'description',
  candidateExperienceId: 'candidateExperienceId'
} as const

export type CandidateExperienceRoleScalarFieldEnum = (typeof CandidateExperienceRoleScalarFieldEnum)[keyof typeof CandidateExperienceRoleScalarFieldEnum]


export const CandidateExperienceProjectScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  title: 'title',
  description: 'description',
  clientName: 'clientName',
  timeframe: 'timeframe',
  techStack: 'techStack',
  publicUrls: 'publicUrls',
  candidateExperienceRoleId: 'candidateExperienceRoleId'
} as const

export type CandidateExperienceProjectScalarFieldEnum = (typeof CandidateExperienceProjectScalarFieldEnum)[keyof typeof CandidateExperienceProjectScalarFieldEnum]


export const CandidateQualificationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  jacdId: 'jacdId',
  qualification: 'qualification',
  title: 'title',
  university: 'university',
  fieldOfStudy: 'fieldOfStudy',
  location: 'location',
  grade: 'grade',
  startDate: 'startDate',
  endDate: 'endDate',
  latestQualification: 'latestQualification'
} as const

export type CandidateQualificationScalarFieldEnum = (typeof CandidateQualificationScalarFieldEnum)[keyof typeof CandidateQualificationScalarFieldEnum]


export const CandidateSkillScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  jacdId: 'jacdId',
  name: 'name',
  proficiency: 'proficiency',
  extraInformation: 'extraInformation'
} as const

export type CandidateSkillScalarFieldEnum = (typeof CandidateSkillScalarFieldEnum)[keyof typeof CandidateSkillScalarFieldEnum]


export const SourceScalarFieldEnum = {
  id: 'id',
  refereeEmployeeId: 'refereeEmployeeId',
  refereePhone: 'refereePhone',
  refereeFirstName: 'refereeFirstName',
  refereeLastName: 'refereeLastName',
  relationshipToCandidate: 'relationshipToCandidate',
  refereeEmail: 'refereeEmail',
  referralStatus: 'referralStatus',
  internalEmployeeNumber: 'internalEmployeeNumber',
  consultantCompanyName: 'consultantCompanyName',
  consultantName: 'consultantName',
  consultantEmail: 'consultantEmail',
  applicationType: 'applicationType',
  jobApplicationId: 'jobApplicationId',
  candidateId: 'candidateId'
} as const

export type SourceScalarFieldEnum = (typeof SourceScalarFieldEnum)[keyof typeof SourceScalarFieldEnum]


export const WhatsAppThreadScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  companyId: 'companyId',
  candidatePhone: 'candidatePhone',
  senderNumber: 'senderNumber',
  contextType: 'contextType',
  contextId: 'contextId',
  status: 'status',
  messages: 'messages',
  pendingAction: 'pendingAction',
  waRescheduleCount: 'waRescheduleCount',
  lastInboundAt: 'lastInboundAt',
  lastOutboundAt: 'lastOutboundAt',
  processingUntil: 'processingUntil',
  closedReason: 'closedReason'
} as const

export type WhatsAppThreadScalarFieldEnum = (typeof WhatsAppThreadScalarFieldEnum)[keyof typeof WhatsAppThreadScalarFieldEnum]


export const WhatsAppHistoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  companyId: 'companyId',
  candidatePhone: 'candidatePhone',
  candidateEmail: 'candidateEmail',
  conversationHistory: 'conversationHistory',
  engaged: 'engaged',
  existingResumeUrl: 'existingResumeUrl',
  updatedResumeUrl: 'updatedResumeUrl',
  interested: 'interested',
  completed: 'completed',
  currentStep: 'currentStep',
  selectedLanguage: 'selectedLanguage',
  currentCompensation: 'currentCompensation',
  expectedCompensation: 'expectedCompensation',
  noticePeriod: 'noticePeriod',
  shortForm: 'shortForm',
  isMeetingScheduled: 'isMeetingScheduled',
  errorCount: 'errorCount',
  jobPostingId: 'jobPostingId',
  meetingTimeSlot: 'meetingTimeSlot',
  timezone: 'timezone'
} as const

export type WhatsAppHistoryScalarFieldEnum = (typeof WhatsAppHistoryScalarFieldEnum)[keyof typeof WhatsAppHistoryScalarFieldEnum]


export const MetricsScalarFieldEnum = {
  companyId: 'companyId',
  countJobs: 'countJobs',
  countApplications: 'countApplications',
  countCandidates: 'countCandidates',
  countOpenJobs: 'countOpenJobs',
  countOfferedJobs: 'countOfferedJobs',
  countInReview: 'countInReview',
  countShortlisted: 'countShortlisted',
  countInterviewed: 'countInterviewed',
  countOffered: 'countOffered',
  countDirectApp: 'countDirectApp',
  countReferralApp: 'countReferralApp',
  countInternalApp: 'countInternalApp',
  countConsultantApp: 'countConsultantApp',
  jobAgeing: 'jobAgeing',
  jobOfferedAgeing: 'jobOfferedAgeing',
  jobCountOver90: 'jobCountOver90',
  jobCountOver30Below60: 'jobCountOver30Below60',
  jobCountOver60Below90: 'jobCountOver60Below90',
  jobCountBelow30: 'jobCountBelow30',
  offerAgeingOver90: 'offerAgeingOver90',
  offerAgeingOver30Below60: 'offerAgeingOver30Below60',
  offerAgeingOver60Below90: 'offerAgeingOver60Below90',
  offerAgeingBelow30: 'offerAgeingBelow30',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type MetricsScalarFieldEnum = (typeof MetricsScalarFieldEnum)[keyof typeof MetricsScalarFieldEnum]


export const InterviewScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  jobApplicationId: 'jobApplicationId',
  finalComments: 'finalComments',
  finalStatus: 'finalStatus'
} as const

export type InterviewScalarFieldEnum = (typeof InterviewScalarFieldEnum)[keyof typeof InterviewScalarFieldEnum]


export const InterviewRoundScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  interviewDate: 'interviewDate',
  timezone: 'timezone',
  duration: 'duration',
  status: 'status',
  schedulingToken: 'schedulingToken',
  schedulingRange: 'schedulingRange',
  meetingId: 'meetingId',
  meetingLink: 'meetingLink',
  eventId: 'eventId',
  roundType: 'roundType',
  roundNum: 'roundNum',
  recordingUrl: 'recordingUrl',
  questions: 'questions',
  interviewId: 'interviewId',
  isFaceToFaceInterview: 'isFaceToFaceInterview',
  interviewLocation: 'interviewLocation',
  panelistToken: 'panelistToken',
  panelistTokenExpiry: 'panelistTokenExpiry',
  selectedSlots: 'selectedSlots'
} as const

export type InterviewRoundScalarFieldEnum = (typeof InterviewRoundScalarFieldEnum)[keyof typeof InterviewRoundScalarFieldEnum]


export const PanellistFeedbackScalarFieldEnum = {
  name: 'name',
  email: 'email',
  comments: 'comments',
  recommendation: 'recommendation',
  accessToken: 'accessToken',
  status: 'status',
  draftNotes: 'draftNotes',
  interviewRoundId: 'interviewRoundId',
  finalFeedback: 'finalFeedback',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PanellistFeedbackScalarFieldEnum = (typeof PanellistFeedbackScalarFieldEnum)[keyof typeof PanellistFeedbackScalarFieldEnum]


export const AssessmentTemplateScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  departmentId: 'departmentId',
  level: 'level',
  parameterOrder: 'parameterOrder',
  companyId: 'companyId'
} as const

export type AssessmentTemplateScalarFieldEnum = (typeof AssessmentTemplateScalarFieldEnum)[keyof typeof AssessmentTemplateScalarFieldEnum]


export const AssessmentParameterScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  parameter: 'parameter',
  definition: 'definition',
  questions: 'questions',
  answers: 'answers',
  enableAIQuestionGeneration: 'enableAIQuestionGeneration',
  enableAIHumanQuestionGeneration: 'enableAIHumanQuestionGeneration',
  phoneQuestionType: 'phoneQuestionType',
  interviewId: 'interviewId',
  companyId: 'companyId'
} as const

export type AssessmentParameterScalarFieldEnum = (typeof AssessmentParameterScalarFieldEnum)[keyof typeof AssessmentParameterScalarFieldEnum]


export const AssessmentTemplateParametersScalarFieldEnum = {
  assessmentParameterId: 'assessmentParameterId',
  assessmentTemplateId: 'assessmentTemplateId',
  isAIScreening: 'isAIScreening',
  isPanelistInterview: 'isPanelistInterview',
  isPhoneScreening: 'isPhoneScreening'
} as const

export type AssessmentTemplateParametersScalarFieldEnum = (typeof AssessmentTemplateParametersScalarFieldEnum)[keyof typeof AssessmentTemplateParametersScalarFieldEnum]


export const ParameterRatingScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  rating: 'rating',
  comment: 'comment',
  assessmentParameterId: 'assessmentParameterId',
  panellistEmail: 'panellistEmail',
  interviewRoundId: 'interviewRoundId'
} as const

export type ParameterRatingScalarFieldEnum = (typeof ParameterRatingScalarFieldEnum)[keyof typeof ParameterRatingScalarFieldEnum]


export const InterviewPanelistParameterAssignmentScalarFieldEnum = {
  panellistEmail: 'panellistEmail',
  interviewRoundId: 'interviewRoundId',
  assessmentParameterId: 'assessmentParameterId',
  createdAt: 'createdAt'
} as const

export type InterviewPanelistParameterAssignmentScalarFieldEnum = (typeof InterviewPanelistParameterAssignmentScalarFieldEnum)[keyof typeof InterviewPanelistParameterAssignmentScalarFieldEnum]


export const ScreeningInterviewScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  interviewId: 'interviewId',
  questions: 'questions',
  roomName: 'roomName',
  roomToken: 'roomToken',
  roomTokenExpiry: 'roomTokenExpiry',
  recordingUrl: 'recordingUrl',
  status: 'status',
  isUserQuestionsGenerated: 'isUserQuestionsGenerated',
  isAiQuestionsGenerated: 'isAiQuestionsGenerated',
  screeningConfig: 'screeningConfig',
  identityVerified: 'identityVerified',
  livenessVerificationStatus: 'livenessVerificationStatus',
  proctoringEvents: 'proctoringEvents',
  interviewEvents: 'interviewEvents',
  clientToken: 'clientToken',
  clientTokenExpiry: 'clientTokenExpiry',
  speechTokenIssued: 'speechTokenIssued',
  interviewTransport: 'interviewTransport',
  recordingWorkingUrl: 'recordingWorkingUrl',
  recordingStatus: 'recordingStatus',
  recordingUploadMeta: 'recordingUploadMeta',
  webrtcSessionLog: 'webrtcSessionLog',
  clientDecisionLogUrl: 'clientDecisionLogUrl',
  scoringTriggered: 'scoringTriggered'
} as const

export type ScreeningInterviewScalarFieldEnum = (typeof ScreeningInterviewScalarFieldEnum)[keyof typeof ScreeningInterviewScalarFieldEnum]


export const ScreeningCallScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  interviewId: 'interviewId',
  candidatePhoneNumber: 'candidatePhoneNumber',
  scheduledAt: 'scheduledAt',
  questions: 'questions',
  status: 'status',
  isUserQuestionsGenerated: 'isUserQuestionsGenerated',
  isAiQuestionsGenerated: 'isAiQuestionsGenerated',
  screeningConfig: 'screeningConfig',
  callEvents: 'callEvents',
  recordingUrl: 'recordingUrl',
  transcriptUrl: 'transcriptUrl',
  interviewStateUrl: 'interviewStateUrl',
  clientDecisionLogUrl: 'clientDecisionLogUrl',
  scoringTriggered: 'scoringTriggered',
  roundNum: 'roundNum',
  currentAttemptId: 'currentAttemptId',
  attemptNumber: 'attemptNumber',
  noAnswerRetryCount: 'noAnswerRetryCount',
  rescheduleCount: 'rescheduleCount',
  voicemailRetryCount: 'voicemailRetryCount',
  candidateTimezone: 'candidateTimezone',
  objectiveEvaluations: 'objectiveEvaluations',
  callQuality: 'callQuality'
} as const

export type ScreeningCallScalarFieldEnum = (typeof ScreeningCallScalarFieldEnum)[keyof typeof ScreeningCallScalarFieldEnum]


export const PhoneCallLifecycleEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  eventId: 'eventId',
  screeningCallId: 'screeningCallId',
  attemptId: 'attemptId',
  outcome: 'outcome',
  reason: 'reason',
  workflowTriggered: 'workflowTriggered',
  scheduledAt: 'scheduledAt'
} as const

export type PhoneCallLifecycleEventScalarFieldEnum = (typeof PhoneCallLifecycleEventScalarFieldEnum)[keyof typeof PhoneCallLifecycleEventScalarFieldEnum]


export const ScreeningResultScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  overallScore: 'overallScore',
  overallSummary: 'overallSummary',
  answerEvaluations: 'answerEvaluations',
  interviewTranscription: 'interviewTranscription',
  originalTranscript: 'originalTranscript',
  decisionLogUrl: 'decisionLogUrl',
  psychometricAnalysis: 'psychometricAnalysis',
  completionState: 'completionState',
  cefrScoring: 'cefrScoring',
  cheatDetection: 'cheatDetection',
  screeningInterviewId: 'screeningInterviewId',
  screeningCallId: 'screeningCallId'
} as const

export type ScreeningResultScalarFieldEnum = (typeof ScreeningResultScalarFieldEnum)[keyof typeof ScreeningResultScalarFieldEnum]


export const ScreeningSystemMessagesScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  language: 'language',
  message: 'message',
  messageType: 'messageType'
} as const

export type ScreeningSystemMessagesScalarFieldEnum = (typeof ScreeningSystemMessagesScalarFieldEnum)[keyof typeof ScreeningSystemMessagesScalarFieldEnum]


export const SystemSettingsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  language: 'language',
  settingName: 'settingName',
  config: 'config',
  isDefault: 'isDefault'
} as const

export type SystemSettingsScalarFieldEnum = (typeof SystemSettingsScalarFieldEnum)[keyof typeof SystemSettingsScalarFieldEnum]


export const InterviewResultScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  overallScore: 'overallScore',
  overallSummary: 'overallSummary',
  interviewTranscription: 'interviewTranscription',
  interviewRoundId: 'interviewRoundId'
} as const

export type InterviewResultScalarFieldEnum = (typeof InterviewResultScalarFieldEnum)[keyof typeof InterviewResultScalarFieldEnum]


export const ScreeningResultCategoriesScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  categoryScore: 'categoryScore',
  categoryName: 'categoryName',
  reasoning: 'reasoning',
  screeningResultId: 'screeningResultId'
} as const

export type ScreeningResultCategoriesScalarFieldEnum = (typeof ScreeningResultCategoriesScalarFieldEnum)[keyof typeof ScreeningResultCategoriesScalarFieldEnum]


export const CompanyConfigScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  companyId: 'companyId',
  autoApprove: 'autoApprove',
  autoApproveReplacementJobs: 'autoApproveReplacementJobs',
  autoApproveOffers: 'autoApproveOffers',
  autoApproveApplications: 'autoApproveApplications',
  autoPostToNaukri: 'autoPostToNaukri',
  autoPostToLinkedIn: 'autoPostToLinkedIn',
  offerTemplateDocument: 'offerTemplateDocument',
  naukriAPIKey: 'naukriAPIKey',
  naukriTestAccount: 'naukriTestAccount',
  graph_tenant_id: 'graph_tenant_id',
  graph_client_id: 'graph_client_id',
  graph_client_secret: 'graph_client_secret',
  graph_refresh_token: 'graph_refresh_token',
  domain: 'domain',
  careerPageSettingEnabled: 'careerPageSettingEnabled',
  twilioDetails: 'twilioDetails',
  customFieldsConfig: 'customFieldsConfig',
  enableSendingEmail: 'enableSendingEmail',
  isReachOutEnabled: 'isReachOutEnabled',
  accessControlConfig: 'accessControlConfig',
  reportConfig: 'reportConfig',
  showCompanyLogo: 'showCompanyLogo',
  companyLogoUrl: 'companyLogoUrl',
  ogImageUrl: 'ogImageUrl',
  ogImageSourceHash: 'ogImageSourceHash',
  featureFlags: 'featureFlags',
  offerFieldConfig: 'offerFieldConfig',
  extraConfig: 'extraConfig',
  searchConfig: 'searchConfig',
  jdConfig: 'jdConfig',
  linkedInCompanyIds: 'linkedInCompanyIds'
} as const

export type CompanyConfigScalarFieldEnum = (typeof CompanyConfigScalarFieldEnum)[keyof typeof CompanyConfigScalarFieldEnum]


export const IntegrationScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  type: 'type',
  providerName: 'providerName',
  encryptedSecret: 'encryptedSecret',
  encryptionKeyVersion: 'encryptionKeyVersion',
  metadata: 'metadata',
  isActive: 'isActive',
  lastVerifiedAt: 'lastVerifiedAt',
  lastUsedAt: 'lastUsedAt',
  expiresAt: 'expiresAt',
  createdBy: 'createdBy',
  updatedBy: 'updatedBy',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type IntegrationScalarFieldEnum = (typeof IntegrationScalarFieldEnum)[keyof typeof IntegrationScalarFieldEnum]


export const CustomFieldDefinitionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  companyId: 'companyId',
  entityType: 'entityType',
  fieldName: 'fieldName',
  fieldLabel: 'fieldLabel',
  fieldPlaceholder: 'fieldPlaceholder',
  fieldType: 'fieldType',
  fieldValueType: 'fieldValueType',
  fieldOptions: 'fieldOptions',
  dependsOnFieldName: 'dependsOnFieldName',
  dependsOnFieldValue: 'dependsOnFieldValue',
  appendWithStandardOptions: 'appendWithStandardOptions',
  isRequired: 'isRequired',
  isVisible: 'isVisible',
  placementOrdering: 'placementOrdering',
  isExistingField: 'isExistingField',
  isExistingFieldHidden: 'isExistingFieldHidden',
  existingFieldDefaultValue: 'existingFieldDefaultValue',
  displayInputOnGrid: 'displayInputOnGrid',
  isAdditionalInfo: 'isAdditionalInfo',
  updateLabelOnly: 'updateLabelOnly',
  defaultValue: 'defaultValue'
} as const

export type CustomFieldDefinitionScalarFieldEnum = (typeof CustomFieldDefinitionScalarFieldEnum)[keyof typeof CustomFieldDefinitionScalarFieldEnum]


export const DefaultApproversScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  companyConfigId: 'companyConfigId',
  email: 'email'
} as const

export type DefaultApproversScalarFieldEnum = (typeof DefaultApproversScalarFieldEnum)[keyof typeof DefaultApproversScalarFieldEnum]


export const JobApproversScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  companyConfigId: 'companyConfigId',
  departmentId: 'departmentId',
  email: 'email',
  level: 'level',
  entityType: 'entityType'
} as const

export type JobApproversScalarFieldEnum = (typeof JobApproversScalarFieldEnum)[keyof typeof JobApproversScalarFieldEnum]


export const ApprovalRoutingRuleScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  companyConfigId: 'companyConfigId',
  departmentId: 'departmentId',
  entityType: 'entityType',
  field: 'field',
  operator: 'operator',
  value: 'value',
  isActive: 'isActive'
} as const

export type ApprovalRoutingRuleScalarFieldEnum = (typeof ApprovalRoutingRuleScalarFieldEnum)[keyof typeof ApprovalRoutingRuleScalarFieldEnum]


export const ApprovalRoutingApproverScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  ruleId: 'ruleId',
  email: 'email',
  level: 'level'
} as const

export type ApprovalRoutingApproverScalarFieldEnum = (typeof ApprovalRoutingApproverScalarFieldEnum)[keyof typeof ApprovalRoutingApproverScalarFieldEnum]


export const ApprovalsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  jobApprovalSlug: 'jobApprovalSlug',
  isApproved: 'isApproved',
  jobPostingId: 'jobPostingId',
  jobApproverId: 'jobApproverId',
  entityId: 'entityId',
  comments: 'comments'
} as const

export type ApprovalsScalarFieldEnum = (typeof ApprovalsScalarFieldEnum)[keyof typeof ApprovalsScalarFieldEnum]


export const JobOffersScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  jobApplicationId: 'jobApplicationId',
  jobOpeningId: 'jobOpeningId',
  startDate: 'startDate',
  isAccepted: 'isAccepted',
  jobOfferSlug: 'jobOfferSlug',
  travelAllowance: 'travelAllowance',
  totalCompensation: 'totalCompensation',
  isApproved: 'isApproved',
  isValidated: 'isValidated',
  offerDocumentUrl: 'offerDocumentUrl',
  activityLog: 'activityLog',
  comments: 'comments',
  customFields: 'customFields'
} as const

export type JobOffersScalarFieldEnum = (typeof JobOffersScalarFieldEnum)[keyof typeof JobOffersScalarFieldEnum]


export const JobOfferDocumentsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  jobOfferId: 'jobOfferId',
  offerDocumentUrl: 'offerDocumentUrl'
} as const

export type JobOfferDocumentsScalarFieldEnum = (typeof JobOfferDocumentsScalarFieldEnum)[keyof typeof JobOfferDocumentsScalarFieldEnum]


export const NotificationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  message: 'message',
  isRead: 'isRead',
  notificationType: 'notificationType',
  fromUserEmail: 'fromUserEmail',
  toUserEmail: 'toUserEmail',
  link: 'link'
} as const

export type NotificationScalarFieldEnum = (typeof NotificationScalarFieldEnum)[keyof typeof NotificationScalarFieldEnum]


export const DailyWebhookEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  eventType: 'eventType',
  roomName: 'roomName',
  roomId: 'roomId',
  eventId: 'eventId',
  participantId: 'participantId',
  recordingId: 'recordingId',
  startedAt: 'startedAt',
  endedAt: 'endedAt',
  status: 'status',
  payload: 'payload'
} as const

export type DailyWebhookEventScalarFieldEnum = (typeof DailyWebhookEventScalarFieldEnum)[keyof typeof DailyWebhookEventScalarFieldEnum]


export const CandidateNotesScalarFieldEnum = {
  id: 'id',
  note: 'note',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdBy: 'createdBy',
  jobApplicationId: 'jobApplicationId',
  candidateId: 'candidateId',
  sourcedCandidateId: 'sourcedCandidateId'
} as const

export type CandidateNotesScalarFieldEnum = (typeof CandidateNotesScalarFieldEnum)[keyof typeof CandidateNotesScalarFieldEnum]


export const JobOpeningsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  jobPostingId: 'jobPostingId',
  positionId: 'positionId',
  status: 'status',
  isOffered: 'isOffered',
  deletedAt: 'deletedAt',
  jobOfferId: 'jobOfferId',
  linkedApplicationId: 'linkedApplicationId',
  activityHistory: 'activityHistory'
} as const

export type JobOpeningsScalarFieldEnum = (typeof JobOpeningsScalarFieldEnum)[keyof typeof JobOpeningsScalarFieldEnum]


export const OfferTemplateDocumentsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  companyConfigId: 'companyConfigId',
  documentUrl: 'documentUrl',
  documentName: 'documentName',
  documentFieldConfig: 'documentFieldConfig',
  departmentId: 'departmentId',
  grade: 'grade',
  convertToPdf: 'convertToPdf',
  offerEmailBody: 'offerEmailBody'
} as const

export type OfferTemplateDocumentsScalarFieldEnum = (typeof OfferTemplateDocumentsScalarFieldEnum)[keyof typeof OfferTemplateDocumentsScalarFieldEnum]


export const FaceLivenessVerificationScalarFieldEnum = {
  id: 'id',
  screeningInterviewId: 'screeningInterviewId',
  awsSessionId: 'awsSessionId',
  status: 'status',
  confidence: 'confidence',
  auditImages: 'auditImages',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type FaceLivenessVerificationScalarFieldEnum = (typeof FaceLivenessVerificationScalarFieldEnum)[keyof typeof FaceLivenessVerificationScalarFieldEnum]


export const SearchTriggerErrorsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  entityType: 'entityType',
  entityId: 'entityId',
  triggerName: 'triggerName',
  errorType: 'errorType',
  errorMessage: 'errorMessage',
  sqlState: 'sqlState',
  context: 'context'
} as const

export type SearchTriggerErrorsScalarFieldEnum = (typeof SearchTriggerErrorsScalarFieldEnum)[keyof typeof SearchTriggerErrorsScalarFieldEnum]


export const Candidate_search_trigger_errorsScalarFieldEnum = {
  id: 'id',
  candidate_id: 'candidate_id',
  error_msg: 'error_msg',
  created_at: 'created_at'
} as const

export type Candidate_search_trigger_errorsScalarFieldEnum = (typeof Candidate_search_trigger_errorsScalarFieldEnum)[keyof typeof Candidate_search_trigger_errorsScalarFieldEnum]


export const StatusChangeMetricsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  date: 'date',
  companyId: 'companyId',
  statusCount: 'statusCount'
} as const

export type StatusChangeMetricsScalarFieldEnum = (typeof StatusChangeMetricsScalarFieldEnum)[keyof typeof StatusChangeMetricsScalarFieldEnum]


export const AdminAuditLogsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  userEmail: 'userEmail',
  action: 'action',
  companyId: 'companyId',
  prevData: 'prevData',
  newData: 'newData'
} as const

export type AdminAuditLogsScalarFieldEnum = (typeof AdminAuditLogsScalarFieldEnum)[keyof typeof AdminAuditLogsScalarFieldEnum]


export const CustomChartConfigScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  type: 'type',
  config: 'config',
  title: 'title',
  dashboardId: 'dashboardId'
} as const

export type CustomChartConfigScalarFieldEnum = (typeof CustomChartConfigScalarFieldEnum)[keyof typeof CustomChartConfigScalarFieldEnum]


export const EmbeddingScalarFieldEnum = {
  id: 'id',
  clientId: 'clientId',
  entityType: 'entityType',
  companyId: 'companyId',
  chunkIndex: 'chunkIndex',
  textChunk: 'textChunk',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type EmbeddingScalarFieldEnum = (typeof EmbeddingScalarFieldEnum)[keyof typeof EmbeddingScalarFieldEnum]


export const JobDescriptionScalarFieldEnum = {
  id: 'id',
  title: 'title',
  content: 'content',
  notes: 'notes',
  status: 'status',
  isFinal: 'isFinal',
  companyId: 'companyId',
  createdBy: 'createdBy',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type JobDescriptionScalarFieldEnum = (typeof JobDescriptionScalarFieldEnum)[keyof typeof JobDescriptionScalarFieldEnum]


export const JDLangGraphStateScalarFieldEnum = {
  id: 'id',
  jobDescId: 'jobDescId',
  langGraphState: 'langGraphState',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type JDLangGraphStateScalarFieldEnum = (typeof JDLangGraphStateScalarFieldEnum)[keyof typeof JDLangGraphStateScalarFieldEnum]


export const ReferenceJDScalarFieldEnum = {
  id: 'id',
  jobDescId: 'jobDescId',
  filename: 'filename',
  originalName: 'originalName',
  mimeType: 'mimeType',
  size: 'size',
  fileUrl: 'fileUrl',
  extractedText: 'extractedText',
  processingStatus: 'processingStatus',
  processingError: 'processingError',
  uploadedBy: 'uploadedBy',
  uploadedAt: 'uploadedAt',
  processedAt: 'processedAt'
} as const

export type ReferenceJDScalarFieldEnum = (typeof ReferenceJDScalarFieldEnum)[keyof typeof ReferenceJDScalarFieldEnum]


export const InviteResponseScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  email: 'email',
  type: 'type',
  status: 'status',
  reason: 'reason',
  responseTime: 'responseTime',
  responseToken: 'responseToken',
  interviewRoundId: 'interviewRoundId'
} as const

export type InviteResponseScalarFieldEnum = (typeof InviteResponseScalarFieldEnum)[keyof typeof InviteResponseScalarFieldEnum]


export const InterviewDeclineNotificationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  interviewRoundId: 'interviewRoundId',
  attendeeEmail: 'attendeeEmail',
  attendeeType: 'attendeeType',
  notifiedAt: 'notifiedAt'
} as const

export type InterviewDeclineNotificationScalarFieldEnum = (typeof InterviewDeclineNotificationScalarFieldEnum)[keyof typeof InterviewDeclineNotificationScalarFieldEnum]


export const DocumentRequestsScalarFieldEnum = {
  jobOpeningId: 'jobOpeningId',
  jobApplicationId: 'jobApplicationId',
  documents: 'documents',
  updatedAt: 'updatedAt'
} as const

export type DocumentRequestsScalarFieldEnum = (typeof DocumentRequestsScalarFieldEnum)[keyof typeof DocumentRequestsScalarFieldEnum]


export const CandidateSharingScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  sharingSlug: 'sharingSlug',
  expiresAt: 'expiresAt',
  companyId: 'companyId',
  jobPostingId: 'jobPostingId',
  senderEmail: 'senderEmail',
  hiringManagerEmail: 'hiringManagerEmail',
  jobTitle: 'jobTitle',
  sharedCandidateJacdIds: 'sharedCandidateJacdIds'
} as const

export type CandidateSharingScalarFieldEnum = (typeof CandidateSharingScalarFieldEnum)[keyof typeof CandidateSharingScalarFieldEnum]


export const TalentPoolJobInviteScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  companyId: 'companyId',
  jobPostingId: 'jobPostingId',
  candidateId: 'candidateId',
  jacdId: 'jacdId',
  candidateEmail: 'candidateEmail',
  candidateName: 'candidateName',
  status: 'status',
  invitedByEmail: 'invitedByEmail',
  customMessage: 'customMessage',
  applyUrl: 'applyUrl',
  sentAt: 'sentAt',
  emailError: 'emailError',
  jobApplicationId: 'jobApplicationId',
  appliedAt: 'appliedAt'
} as const

export type TalentPoolJobInviteScalarFieldEnum = (typeof TalentPoolJobInviteScalarFieldEnum)[keyof typeof TalentPoolJobInviteScalarFieldEnum]


export const JobSourcedCandidateScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  companyId: 'companyId',
  jobPostingId: 'jobPostingId',
  firstName: 'firstName',
  lastName: 'lastName',
  headline: 'headline',
  currentCompany: 'currentCompany',
  currentDesignation: 'currentDesignation',
  location: 'location',
  linkedInUrl: 'linkedInUrl',
  email: 'email',
  phone: 'phone',
  profile: 'profile',
  pageUrl: 'pageUrl',
  source: 'source',
  note: 'note',
  status: 'status',
  addedByEmail: 'addedByEmail',
  contactedAt: 'contactedAt',
  invitedAt: 'invitedAt',
  appliedAt: 'appliedAt',
  archivedAt: 'archivedAt',
  jobApplicationId: 'jobApplicationId'
} as const

export type JobSourcedCandidateScalarFieldEnum = (typeof JobSourcedCandidateScalarFieldEnum)[keyof typeof JobSourcedCandidateScalarFieldEnum]


export const JDAgentConversationScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  conversationId: 'conversationId',
  jdId: 'jdId',
  collectedData: 'collectedData',
  messages: 'messages',
  status: 'status'
} as const

export type JDAgentConversationScalarFieldEnum = (typeof JDAgentConversationScalarFieldEnum)[keyof typeof JDAgentConversationScalarFieldEnum]


export const CommunicationServiceStatusScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  messageId: 'messageId',
  recipient: 'recipient',
  sender: 'sender',
  clientId: 'clientId',
  clientType: 'clientType',
  meta: 'meta'
} as const

export type CommunicationServiceStatusScalarFieldEnum = (typeof CommunicationServiceStatusScalarFieldEnum)[keyof typeof CommunicationServiceStatusScalarFieldEnum]


export const CommunicationTemplateScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  content: 'content',
  params: 'params',
  purpose: 'purpose',
  type: 'type',
  status: 'status',
  isActive: 'isActive',
  companyId: 'companyId',
  creatorId: 'creatorId'
} as const

export type CommunicationTemplateScalarFieldEnum = (typeof CommunicationTemplateScalarFieldEnum)[keyof typeof CommunicationTemplateScalarFieldEnum]


export const BillingCreditCostSetScalarFieldEnum = {
  id: 'id',
  name: 'name',
  code: 'code',
  isDefault: 'isDefault',
  costs: 'costs',
  unitAmountCents: 'unitAmountCents',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type BillingCreditCostSetScalarFieldEnum = (typeof BillingCreditCostSetScalarFieldEnum)[keyof typeof BillingCreditCostSetScalarFieldEnum]


export const BillingPlanScalarFieldEnum = {
  id: 'id',
  code: 'code',
  name: 'name',
  description: 'description',
  isActive: 'isActive',
  isPublic: 'isPublic',
  isFreemium: 'isFreemium',
  stripeProductId: 'stripeProductId',
  stripePriceId: 'stripePriceId',
  stripeAnnualPriceId: 'stripeAnnualPriceId',
  amountCents: 'amountCents',
  includedCredits: 'includedCredits',
  unlimitedCredits: 'unlimitedCredits',
  creditGrantMode: 'creditGrantMode',
  creditCarryoverEnabled: 'creditCarryoverEnabled',
  creditCostSetId: 'creditCostSetId',
  annualDiscountPercent: 'annualDiscountPercent',
  currency: 'currency',
  interval: 'interval',
  trialPeriodDays: 'trialPeriodDays',
  limits: 'limits',
  featureFlags: 'featureFlags',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type BillingPlanScalarFieldEnum = (typeof BillingPlanScalarFieldEnum)[keyof typeof BillingPlanScalarFieldEnum]


export const CompanyCreditBalanceScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  includedCredits: 'includedCredits',
  packCredits: 'packCredits',
  includedPeriodKey: 'includedPeriodKey',
  marleyUnbilledTurns: 'marleyUnbilledTurns',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CompanyCreditBalanceScalarFieldEnum = (typeof CompanyCreditBalanceScalarFieldEnum)[keyof typeof CompanyCreditBalanceScalarFieldEnum]


export const BillingCreditLedgerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  companyId: 'companyId',
  kind: 'kind',
  actionCode: 'actionCode',
  credits: 'credits',
  includedDelta: 'includedDelta',
  packDelta: 'packDelta',
  idempotencyKey: 'idempotencyKey',
  meta: 'meta'
} as const

export type BillingCreditLedgerScalarFieldEnum = (typeof BillingCreditLedgerScalarFieldEnum)[keyof typeof BillingCreditLedgerScalarFieldEnum]


export const BillingSubscriptionScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  planId: 'planId',
  status: 'status',
  stripeCustomerId: 'stripeCustomerId',
  stripeSubscriptionId: 'stripeSubscriptionId',
  billingInterval: 'billingInterval',
  currentPeriodEnd: 'currentPeriodEnd',
  stripePauseResumesAt: 'stripePauseResumesAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type BillingSubscriptionScalarFieldEnum = (typeof BillingSubscriptionScalarFieldEnum)[keyof typeof BillingSubscriptionScalarFieldEnum]


export const BillingCapacityGrantScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  companyId: 'companyId',
  blockSize: 'blockSize',
  scope: 'scope',
  periodKey: 'periodKey',
  lastBilledPeriodKey: 'lastBilledPeriodKey',
  stripeInvoiceItemId: 'stripeInvoiceItemId',
  requestedByUserId: 'requestedByUserId',
  meta: 'meta'
} as const

export type BillingCapacityGrantScalarFieldEnum = (typeof BillingCapacityGrantScalarFieldEnum)[keyof typeof BillingCapacityGrantScalarFieldEnum]


export const BillingSignupDraftScalarFieldEnum = {
  id: 'id',
  email: 'email',
  authUserId: 'authUserId',
  name: 'name',
  emailVerified: 'emailVerified',
  companyName: 'companyName',
  companySlug: 'companySlug',
  companyLogoUrl: 'companyLogoUrl',
  domain: 'domain',
  planId: 'planId',
  stripeCheckoutSessionId: 'stripeCheckoutSessionId',
  status: 'status',
  provisionedCompanyId: 'provisionedCompanyId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type BillingSignupDraftScalarFieldEnum = (typeof BillingSignupDraftScalarFieldEnum)[keyof typeof BillingSignupDraftScalarFieldEnum]


export const OneTimePasswordScalarFieldEnum = {
  id: 'id',
  purpose: 'purpose',
  subjectId: 'subjectId',
  codeHash: 'codeHash',
  expiresAt: 'expiresAt',
  attemptCount: 'attemptCount',
  lastSentAt: 'lastSentAt',
  consumedAt: 'consumedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type OneTimePasswordScalarFieldEnum = (typeof OneTimePasswordScalarFieldEnum)[keyof typeof OneTimePasswordScalarFieldEnum]


export const BillingEventLedgerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  companyId: 'companyId',
  kind: 'kind',
  status: 'status',
  linkedIds: 'linkedIds',
  uploadBatchId: 'uploadBatchId',
  meta: 'meta'
} as const

export type BillingEventLedgerScalarFieldEnum = (typeof BillingEventLedgerScalarFieldEnum)[keyof typeof BillingEventLedgerScalarFieldEnum]


export const InterviewQualityReportScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  interviewId: 'interviewId',
  channel: 'channel',
  trigger: 'trigger',
  companyId: 'companyId',
  screeningInterviewId: 'screeningInterviewId',
  screeningCallId: 'screeningCallId',
  workflowId: 'workflowId',
  detectorVersion: 'detectorVersion',
  judgePromptVersion: 'judgePromptVersion',
  judgeModel: 'judgeModel',
  judgeScore: 'judgeScore',
  summary: 'summary',
  metrics: 'metrics',
  issueCount: 'issueCount',
  maxSeverity: 'maxSeverity'
} as const

export type InterviewQualityReportScalarFieldEnum = (typeof InterviewQualityReportScalarFieldEnum)[keyof typeof InterviewQualityReportScalarFieldEnum]


export const InterviewQualityIssueScalarFieldEnum = {
  id: 'id',
  reportId: 'reportId',
  category: 'category',
  otherLabel: 'otherLabel',
  severity: 'severity',
  source: 'source',
  confidence: 'confidence',
  offsetMs: 'offsetMs',
  questionIndex: 'questionIndex',
  title: 'title',
  explanation: 'explanation',
  evidence: 'evidence',
  triageStatus: 'triageStatus',
  triageNote: 'triageNote',
  triagedBy: 'triagedBy',
  triagedAt: 'triagedAt'
} as const

export type InterviewQualityIssueScalarFieldEnum = (typeof InterviewQualityIssueScalarFieldEnum)[keyof typeof InterviewQualityIssueScalarFieldEnum]


export const InterviewQualityRunScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  interviewId: 'interviewId',
  channel: 'channel',
  status: 'status',
  workflowId: 'workflowId',
  requestedBy: 'requestedBy',
  reportId: 'reportId',
  error: 'error',
  completedAt: 'completedAt'
} as const

export type InterviewQualityRunScalarFieldEnum = (typeof InterviewQualityRunScalarFieldEnum)[keyof typeof InterviewQualityRunScalarFieldEnum]


export const SortOrder = {
  asc: 'asc',
  desc: 'desc'
} as const

export type SortOrder = (typeof SortOrder)[keyof typeof SortOrder]


export const JsonNullValueInput = {
  JsonNull: JsonNull
} as const

export type JsonNullValueInput = (typeof JsonNullValueInput)[keyof typeof JsonNullValueInput]


export const NullableJsonNullValueInput = {
  DbNull: DbNull,
  JsonNull: JsonNull
} as const

export type NullableJsonNullValueInput = (typeof NullableJsonNullValueInput)[keyof typeof NullableJsonNullValueInput]


export const QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
} as const

export type QueryMode = (typeof QueryMode)[keyof typeof QueryMode]


export const NullsOrder = {
  first: 'first',
  last: 'last'
} as const

export type NullsOrder = (typeof NullsOrder)[keyof typeof NullsOrder]


export const JsonNullValueFilter = {
  DbNull: DbNull,
  JsonNull: JsonNull,
  AnyNull: AnyNull
} as const

export type JsonNullValueFilter = (typeof JsonNullValueFilter)[keyof typeof JsonNullValueFilter]

